export default "__VITE_ASSET__BAt5G2uw__"